import { AxiosInstance } from 'axios';
import i18next from 'i18next';

export class OrganizationsService {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getOrganizations = async () => {
    const response = await this.axiosInstance.get(`/api/instructor`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error(i18next.t('GetOrganizationsError', { ns: 'organizationPage' }));
  };
}

export default OrganizationsService;
